/* eslint-disable import/no-anonymous-default-export */
import * as React from 'react';
import {
    FilterList,
    FilterLiveSearch,
    FilterListItem,
    useGetIdentity,
    useListContext,
} from 'react-admin';
import { Box, TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { endOfYesterday, startOfWeek, startOfMonth, subMonths } from 'date-fns';
import { useConfigurationContext } from '../../root/ConfigurationContext';
import { Transaction } from "../../types/types";

export const TransactionListFilter = ({ searchTerm, setSearchTerm }: { searchTerm: string, setSearchTerm: (value: string) => void }) => {
    const { setFilters } = useListContext();
    const { noteStatuses } = useConfigurationContext();
    const { identity } = useGetIdentity();

    /*
    // Extract unique corporations from funds
    const uniqueCorporations = Array.from(
        new Set(Object.values(txs).map(tx => tx.fund_name))
    );
    */

    return (
        <Box width="13em" minWidth="13em" order={-1} mr={2} mt={5}>
            <TextField
                variant="filled" // Matches FilterLiveSearch appearance
                fullWidth
                hiddenLabel
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // Only updates local state
                sx={{
                    "& .MuiFilledInput-root": {
                        borderRadius: "4px", // Same rounded corners
                        width: "100%",
                    },
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchTerm ? (
                                <IconButton size="small" onClick={() => setSearchTerm("")}>
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            ) : (
                                <SearchIcon sx={{ opacity: 0.3 }} />
                            )}
                        </InputAdornment>
                    ),
                }}
            />


            <FilterList label="Type" icon={<SwapHorizIcon />}>
                <FilterListItem label="Deposit" value={{ transfer_type: "deposit" }} />
                <FilterListItem label="Withdrawal" value={{ transfer_type: "withdrawal" }} />
                <FilterListItem label="Reward" value={{ transfer_type: "reward" }} />
            </FilterList>

            <FilterList label="Status" icon={<TimelapseIcon />}>
                <FilterListItem label="Completed" value={{ status: "completed" }} />
                <FilterListItem label="Pending" value={{ status: "pending" }} />
                <FilterListItem label="Canceled" value={{ status: "canceled" }} />
            </FilterList>

        </Box>
    );
};
